export const getRateAsIntegerAndFraction = (rate) => {
  return {
    integer: rate ? rate.toFixed(2).slice(0, -3) : 0,
    fraction: rate ? rate.toFixed(2).slice(-2) : 0,
  }
}

export const getFeeAsIntegerAndFraction = (fee) => {
  if (fee) {
    return {
      integer: fee.toFixed(4).slice(2, 4),
      fraction: fee.toFixed(4).slice(4, 6),
    }
  }
  return {}
}
